const TOKEN_KEY = 'ollaa_kitchen_session_token';
const EXPIRES_KEY = 'ollaa_kitchen_session_expires';
const LEGACY_ACCESS_KEY = 'ollaa_kitchen_access_token';

if (typeof window !== 'undefined') {
  try {
    window.localStorage.removeItem(LEGACY_ACCESS_KEY);
  } catch {
    // ignore
  }
}

const readExpiresMs = () => {
  try {
    const raw = sessionStorage.getItem(EXPIRES_KEY);
    if (!raw) return null;
    const ts = Date.parse(raw);
    return Number.isFinite(ts) ? ts : null;
  } catch {
    return null;
  }
};

export const getKitchenSessionToken = () => {
  if (typeof window === 'undefined') return '';
  const token = String(sessionStorage.getItem(TOKEN_KEY) || '').trim();
  if (!token) return '';
  const expires = readExpiresMs();
  if (expires != null && expires <= Date.now()) {
    clearKitchenSession();
    return '';
  }
  return token;
};

export const setKitchenSession = ({ sessionToken, expiresAt }) => {
  if (typeof window === 'undefined') return;
  const token = String(sessionToken || '').trim();
  if (!token) {
    clearKitchenSession();
    return;
  }
  sessionStorage.setItem(TOKEN_KEY, token);
  if (expiresAt) {
    sessionStorage.setItem(EXPIRES_KEY, expiresAt);
  }
  import('@/utils/kitchenPush').then(({ resetKitchenPushInit }) => {
    resetKitchenPushInit();
  }).catch(() => {});
};

export const clearKitchenSession = () => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(EXPIRES_KEY);
  } catch {
    // ignore
  }
  import('@/utils/kitchenPush').then(({ resetKitchenPushInit }) => {
    resetKitchenPushInit();
  }).catch(() => {});
};

export const hasValidKitchenSession = () => Boolean(getKitchenSessionToken());
